import { useEffect, useRef, useState } from "react";
import Container from "../../components/common/Container";
import ImageGallery from "../../components/common/ImageGallery";

export default function Slot() {
  document.title = "Slot";
  const [royalCasinoApi, setRoyalCasino] = useState();
  const initialized = useRef(false);

  useEffect(() => {
    if (localStorage.getItem("Slot")) {
      let paresData = JSON.parse(localStorage.getItem("Slot"));
      setRoyalCasino(paresData);
    }
    if (!initialized.current) {
      initialized.current = true;
      callAPI();
    }
  }, []);

  const callAPI = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/other_casinoPage?category=slot`,
      requestOptions
    )
      .then(async (response) => {
        let paresData = await response.json();
        setRoyalCasino(paresData);
        localStorage.setItem("Slot", JSON.stringify(paresData));
        console.log("Royal_casino - ", paresData);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <>
      <Container size="full">
        <div className="content-full">
          <div className="home-grid-sec casino-grid-sec">
            {royalCasinoApi ? (
              <div className="home-grid casino-grid">
                {royalCasinoApi && (
                  <ImageGallery allImages={royalCasinoApi.games} />
                )}
              </div>
            ) : (
              <div className="please-wait-data">
                Please wait data is loading...
              </div>
            )}
            {royalCasinoApi && royalCasinoApi.games.length === 0 ? (
              <div className="no-data">No Casino Found!</div>
            ) : (
              ""
            )}
          </div>
        </div>
      </Container>
    </>
  );
}
